import { render, staticRenderFns } from "./CohortMemberTable.vue?vue&type=template&id=532440ef&"
import script from "./CohortMemberTable.vue?vue&type=script&lang=js&"
export * from "./CohortMemberTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports